var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-list',{attrs:{"model":_vm.model,"model-headers":_vm.modelHeaders}})}
var staticRenderFns = []

export { render, staticRenderFns }